import { Divider, Group, Stack, Text, Title } from "@mantine/core";
import { NotificationSubscriptions } from "./NotificationSubscriptions";
import { useCurrentUserNotificationSubscriptions } from "@jasper/use-cases";
import { NotificationEventEnum } from "@jasper/client-models";
import { useAuthContext } from "../../../shared/contexts/AuthContext";
import { usePhoneNumberUpdateModal } from "./usePhoneNumberUpdateModal";

export const NotificationSettings = () => {
  const { user } = useAuthContext();

  const {
    isLoading,
    notificationSubscriptions,
    subscribeToNotification,
    unsubscribeFromNotification,
  } = useCurrentUserNotificationSubscriptions();
  const { promptPhoneNumberUpdateModal } = usePhoneNumberUpdateModal();

  return (
    <Stack m="md">
      <Stack gap="xs">
        <Title order={2} c="primary.2">
          Paramètres de notifications
        </Title>
        <Text c="gray">
          Sélectionnez les notifications que vous souhaitez recevoir et comment
          vous souhaitez les recevoir (email, SMS, etc.).
        </Text>
      </Stack>
      <Divider />
      <Group align="flex-start" gap="xl">
        <Stack gap="xs" flex={3}>
          <Title order={4} c="primary.2">
            Design à valider
          </Title>
          <Text c="gray">
            Ces notifications vous informeront lorsque vous aurez un design à
            valider pour une commande.
          </Text>
        </Stack>
        <NotificationSubscriptions
          flex={4}
          isLoading={isLoading}
          subscriptions={notificationSubscriptions?.ORDER_DESIGN_OPENED ?? {}}
          onChange={async (channel, value) => {
            if (value) {
              if (
                channel === "SMS" &&
                (!user?.phoneNumber || user?.phoneNumber === "NOT_PROVIDED")
              ) {
                const isPhoneNumberUpdated =
                  await promptPhoneNumberUpdateModal();
                if (!isPhoneNumberUpdated) {
                  return;
                }
              }

              subscribeToNotification({
                event: NotificationEventEnum.ORDER_DESIGN_OPENED,
                channel,
              });
            } else {
              unsubscribeFromNotification({
                event: NotificationEventEnum.ORDER_DESIGN_OPENED,
                channel,
              });
            }
          }}
        />
      </Group>
    </Stack>
  );
};
